export const OUTCOME_PAGES_EXP_KEY = 'pen-3596_v1'
